import { Image } from "@aws-amplify/ui-react"
import { useState } from "react"
import type { Branding } from "../schemata/biometry/Branding.js"
import style from "../style/BrandedHeader.module.css"

type Properties = Readonly<{ branding: Branding | undefined }>

/**
 * @description
 *	The logo of the integration, inside a slot of a fixed height so the layout
 *	never moves when the branding arrives.
 *
 * @remarks
 *	The logo is hidden when it fails to load, because CloudFront answers a
 *	missing key with the index page and a 200 status code, which would render
 *	as a broken image.
 */
export default function BrandedHeader({ branding }: Properties) {
	const [isLogoBroken, setIsLogoBroken] = useState(false)
	return (
		<div className={style["branded-header"]}>
			{branding && !isLogoBroken && (
				<Image
					alt={branding.name}
					className={style["branded-header-logo"]}
					onError={() => setIsLogoBroken(true)}
					src={branding.logoPath}
				/>
			)}
		</div>
	)
}
